/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PluginDriftEventFromJSON, PluginDriftEventToJSON } from './PluginDriftEvent';
/**
 * Check if a given object implements the PluginDriftRecentResponse interface.
 */
export function instanceOfPluginDriftRecentResponse(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('events' in value) || value['events'] === undefined)
        return false;
    return true;
}
export function PluginDriftRecentResponseFromJSON(json) {
    return PluginDriftRecentResponseFromJSONTyped(json, false);
}
export function PluginDriftRecentResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'days': json['days'],
        'events': (json['events'].map(PluginDriftEventFromJSON)),
    };
}
export function PluginDriftRecentResponseToJSON(json) {
    return PluginDriftRecentResponseToJSONTyped(json, false);
}
export function PluginDriftRecentResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'days': value['days'],
        'events': (value['events'].map(PluginDriftEventToJSON)),
    };
}
